import { enableMapSet } from 'immer';
import { createStore } from './zustand';
export function createExpandableObjectIdsStore() {
  enableMapSet();
  return createStore((set, __get, __api) => ({
    expandedObjectIds: new Set(),
    expandRow: objectId => set(state => {
      state.expandedObjectIds.add(objectId);
    }),
    collapseRow: objectId => set(state => {
      state.expandedObjectIds.delete(objectId);
    }),
    collapseAll: () => set({
      expandedObjectIds: new Set()
    })
  }), {
    devtools: {
      name: 'ExpandableObjectIdsStore'
    }
  });
}